(function () {
  angular
    .module('specsguardApp')
    .controller('ProjectDocumentsCtrl', ProjectDocumentsCtrl);

  ProjectDocumentsCtrl.$inject = ['$scope', 'project', 'Project', 'ProjectDataservice', '$injector',
    'Labels', '$mdDialog', '$window', 'SimpleDialogFormService', 'ProjectStateManagerService', 'errorMessageService'];

  function ProjectDocumentsCtrl($scope, project, ProjectAPI, ProjectDataservice, $injector,
    Labels, $mdDialog, $window, SimpleDialogFormService, ProjectStateManagerService, errorMessageService) {

    const vm = this;
    vm.LABELS = Labels;

    vm.$onInit = function () {
      // @ts-ignore
      updateProject({updatedProject: project});
      vm.pagination = {
        resultLimit: 4,
      };
      vm.specbookDocs = sortOnDate(vm.specbookDocs);

      setTimeout(() => {
        $scope.sg2AuthService = $injector.get('sg2AuthService');
      }, 500);
    };

    function sortOnDate(docsObject) {
      return docsObject.sort(function (a, b) {
        if (a.date > b.date) {
          return -1;
        }

        return 1;
      });
    }

    vm.addDoc = function (documentType) {
      const version = {
        versionName: project.versionName,
        _id: project.versionId
      };

      const pveModel = {
        documentTitle: project.name,
      };

      const specbookModel = {
        type: false,
        areaList: true,
        basicAreas: true,
        areas: true,
        version,
      };

      $mdDialog.show({
        controller: 'DocumentAddController',
        controllerAs: '$DocumentAddCtrl',
        locals: {
          project: vm.project,
          documentType,
          model: documentType === 'PvE' ? pveModel : specbookModel,
          currentDocs: documentType === 'PvE' ? vm.pveDocs : vm.specbookDocs,
        },
        templateUrl: 'app-legacy/project/documents/document-add/document-add.html',
        clickOutsideToClose: true,
      })
        .then((model) => {
          if (angular.isDefined(model.type)) {
            model.type = model.type ? 'extended' : 'compact';
          }
          return ProjectAPI.generatePdf({_id: project._id, document: model, documentType}).$promise;
        })
        .then((updatedProject) => {
          updateProject({updatedProject, setDataService: true});
        })
        .catch(() => {
        });
    };

    // Redirect to doc uriEncodedPath
    vm.linkToDoc = (index, docId, doc) => {
      $window.open(doc.uriEncodedPath, '_blank');
    };

    vm.tableColumns = [
      {
        type: 'string',
        headerTitle: Labels.getLabel('name'),
        sortable: true,
        displayKey: 'filename',
        hoverKey: 'filename',
        tdClass: 'bold no-click',
        columnClickHandler: vm.linkToDoc,
        validationErrors: {
          uniqueName: vm.LABELS.getLabel('uniquename')
        },
        columnFilter: true,
      }, {
        type: 'string',
        headerTitle: Labels.getLabel('version'),
        sortable: true,
        displayKey: 'versionNumber',
        hoverKey: 'versionNumber',
        tdClass: 'no-click',
        columnClickHandler: vm.linkToDoc,
        columnFilter: true,
      }, {
        type: 'multiSelect',
        headerTitle: Labels.getLabel('createdby'),
        sortable: true,
        displayKey: 'fullName',
        optionDisplayKey: 'fullName',
        optionValueKey: '_id',
        customFilter: filterUsers,
        columnClickHandler: vm.linkToDoc,
        columnFilter: true,
      }, {
        headerTitle: Labels.getLabel('createdon'),
        sortable: true,
        displayKey: 'dateString',
        columnClickHandler: vm.linkToDoc,
        columnFilter: true,
      }, {
        sortable: true,
        displayKey: 'sizeMb',
        headerTitle: Labels.getLabel('sizemb'),
        tdClass: 'no-click',
        columnClickHandler: vm.linkToDoc,
        columnFilter: true,
      }, {
        headerTitle: Labels.getLabel('download'),
        template: 'app-legacy/project/documents/doc.download.template.html',
        columnFilter: true,
      }, {
        headerTitle: vm.LABELS.getPlural('option'),
        tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
        thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
        template: 'app-legacy/project/documents/document.options.template.html',
        columnFilter: true
      }
    ];

    vm.columnFilters = {
      enabled: true,
    };


    vm.deleteDocument = (item) => {
      const options = {
        title: Labels.getLabel('deletedocumenttitle'),
        content: Labels.getLabel('areyousuredeletedocument'),
        warning: Labels.getLabel('thisactioncannotbeundone'),
        ok: Labels.getLabel('delete'),
        ok_icon: 'delete',
        cancel: Labels.getLabel('cancel')
      };
      SimpleDialogFormService.confirm(null, options, item).then(() => {
        executeDeleteDocument(item);
      }).catch(() => {
      });
    };

    function executeDeleteDocument(item) {
      ProjectStateManagerService.project = vm.project;
      const document = ProjectStateManagerService.query(vm.project.downloadableDocuments, {_id: item._id});

      document.active = false;

      ProjectAPI.patchDocument({
        _id: vm.project._id,
        paramId: document._id,
        document: {active: false}
      }).$promise.then(function () {
        errorMessageService.showSuccess(Labels.getLabel('deletedspecification'));
      });

      filterDocs(vm.project.downloadableDocuments);
    }

    function updateProject({updatedProject, setDataService}) {
      vm.project = updatedProject;
      filterDocs(vm.project.downloadableDocuments);
      vm.pveDocUsers = getUsers(vm.pveDocs);
      vm.specbookDocUsers = getUsers(vm.specbookDocs);

      vm.pveDocColumns = [...vm.tableColumns];
      vm.pveDocColumns[2] = Object.assign({}, {filterData: vm.pveDocUsers}, vm.pveDocColumns[2]);

      vm.specbookDocColumns = [...vm.tableColumns];
      vm.specbookDocColumns[2] = Object.assign({}, {filterData: vm.specbookDocUsers}, vm.specbookDocColumns[2]);

      if (setDataService) {
        ProjectDataservice.setProjectById(updatedProject._id, updatedProject);
      }
    }

    const dateOptions = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    };

    function setDocPathsAndMb(docs) {
      return docs.map((doc) => {
        doc.uriEncodedPath = encodeURI(doc.path);
        doc.dateString = new Date(doc.date).toLocaleDateString('nl-NL', dateOptions);
        doc.sizeMb = Number(doc.file.size / 1024 / 1024).toFixed(2);
        return doc;
      });
    }

    function filterDocs(docs) {
      vm.pveDocs = [];
      vm.specbookDocs = [];
      docs.forEach((doc) => {


        if (doc.active !== false) {
          // Object.assign(doc, doc.file);
          doc.filename = doc.file.name;
          // For existing documents we need to visually add the projectName to it.
          // Otherwise you would see an empty doc version.
          doc.versionNumber = doc.file.versionNumber !== '' ? doc.file.versionNumber : doc.file.versionName;

          if (doc.file.documentType === 'PvE') {
            vm.pveDocs.push(doc);
          } else if (doc.file.documentType === 'Specbook') {
            vm.specbookDocs.push(doc);
          }
        }
      });

      // Would it be better to rerender the object client-side?
      vm.specbookDocs = sortOnDate(setDocPathsAndMb(vm.specbookDocs));
      vm.pveDocs = sortOnDate(setDocPathsAndMb(vm.pveDocs));
    }

    function filterUsers(column, doc) {
      return column.filterData.some((item) => item.selected && doc.createdBy.fullName === item.fullName);
    }

    function getUsers(docs) {
      // @ts-ignore
      return Object.values(docs.reduce((acc, doc) => {
        doc.fullName = doc.file.createdBy.fullName;
        acc[doc.file.createdBy._id] = doc.file.createdBy;
        return acc;
      }, {}));
    }
  }
})();
